import React from 'react';
import { Layout } from '../../components/Layout';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Badge } from '../../components/ui/Badge';
import { Container } from '../../components/ui/Container';
import { Section } from '../../components/ui/Section';
import { AlertTriangle, FileText, Scale, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Disclaimer() {
  return <Layout data-id="element-884">
      <Section spacing="lg" data-id="element-885">
        <Container size="lg" data-id="element-886">
          {/* Hero */}
          <div className="mb-12 text-center animate-fade-in-up" data-id="element-887">
            <Badge variant="warning" size="lg" className="mb-6" data-id="element-888">
              Legal Notice
            </Badge>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-slate-100 mb-6" data-id="element-889">
              Legal Disclaimer
            </h1>
            <p className="text-lg md:text-xl text-slate-400 max-w-3xl mx-auto" data-id="element-890">
              Important legal information, limitations of liability, and terms
              of use. Please read carefully.
            </p>
          </div>

          <div className="grid lg:grid-cols-3 gap-8" data-id="element-891">
            {/* Main Content */}
            <div className="lg:col-span-2 space-y-12" data-id="element-892">
              {/* Platform Identity */}
              <section className="animate-fade-in-up animation-delay-100" data-id="element-893">
                <h2 className="text-2xl font-bold text-slate-100 mb-4 font-mono" data-id="element-894">
                  Platform Identity
                </h2>
                <Card glass padding="lg" className="border-l-4 border-cyan-500" data-id="element-895">
                  <div className="space-y-4 text-slate-300 leading-relaxed" data-id="element-896">
                    <p data-id="element-897">
                      <span className="font-semibold text-slate-200" data-id="element-898">
                        CyberSecurityProtocol 101
                      </span>{' '}
                      is an educational and defensive cybersecurity platform
                      developed by{' '}
                      <span className="font-semibold text-slate-200" data-id="element-899">UXER</span>{' '}
                      as part of{' '}
                      <span className="font-semibold text-slate-200" data-id="element-900">
                        Asosiasi Teknologi Informasi & Open Source (ATIOS)
                      </span>
                      .
                    </p>
                    <p data-id="element-901">
                      This platform does not provide offensive tools, exploit
                      instructions, or access to breached or leaked personal
                      data.
                    </p>
                  </div>
                </Card>
              </section>

              {/* General Disclaimer */}
              <section className="animate-fade-in-up animation-delay-200" data-id="element-902">
                <h2 className="text-2xl font-bold text-slate-100 mb-4 font-mono" data-id="element-903">
                  General Disclaimer
                </h2>
                <Card glass padding="lg" data-id="element-904">
                  <div className="space-y-4 text-slate-300 leading-relaxed" data-id="element-905">
                    <p data-id="element-906">
                      The information provided on CyberSecurityProtocol 101 is
                      for educational purposes only. It does not constitute
                      professional security advice, legal advice, or a guarantee
                      of security.
                    </p>
                    <p data-id="element-907">
                      While we strive to keep the information up to date and
                      correct, we make no representations or warranties of any
                      kind, express or implied, about the completeness,
                      accuracy, reliability, suitability, or availability with
                      respect to the website or the information, products,
                      services, or related graphics contained on the website for
                      any purpose.
                    </p>
                  </div>
                </Card>
              </section>

              {/* Limitation of Liability */}
              <section className="animate-fade-in-up animation-delay-300" data-id="element-908">
                <h2 className="text-2xl font-bold text-slate-100 mb-4 font-mono" data-id="element-909">
                  Limitation of Liability
                </h2>
                <Card glass padding="lg" data-id="element-910">
                  <div className="space-y-4 text-slate-400 leading-relaxed" data-id="element-911">
                    <p data-id="element-912">
                      In no event will UXER or Asosiasi Teknologi Informasi &
                      Open Source (ATIOS) be liable for any loss or damage
                      including without limitation, indirect or consequential
                      loss or damage, or any loss or damage whatsoever arising
                      from loss of data or profits arising out of, or in
                      connection with, the use of this website.
                    </p>
                    <p data-id="element-913">
                      Users are responsible for their own security decisions. We
                      strongly recommend consulting qualified professionals for
                      specific security situations, especially regarding
                      critical infrastructure or high-value assets.
                    </p>
                  </div>
                </Card>
              </section>

              {/* Third-Party Links */}
              <section className="animate-fade-in-up animation-delay-400" data-id="element-914">
                <h2 className="text-2xl font-bold text-slate-100 mb-4 font-mono" data-id="element-915">
                  Third-Party Links
                </h2>
                <Card glass padding="lg" data-id="element-916">
                  <p className="text-slate-400 leading-relaxed" data-id="element-917">
                    Through this website, you are able to link to other websites
                    which are not under the control of CyberSecurityProtocol
                    101. We have no control over the nature, content, and
                    availability of those sites. The inclusion of any links does
                    not necessarily imply a recommendation or endorse the views
                    expressed within them.
                  </p>
                </Card>
              </section>

              {/* Offensive Content Policy */}
              <section className="animate-fade-in-up animation-delay-500" data-id="element-918">
                <h2 className="text-2xl font-bold text-slate-100 mb-4 font-mono" data-id="element-919">
                  Offensive Content Policy
                </h2>
                <Card glass padding="lg" className="border-red-500/20" data-id="element-920">
                  <div className="space-y-4" data-id="element-921">
                    <p className="text-red-200 font-bold" data-id="element-922">
                      We strictly prohibit the use of our content for illegal
                      purposes.
                    </p>
                    <p className="text-slate-300 leading-relaxed" data-id="element-923">
                      We do NOT provide offensive hacking techniques, exploits,
                      or instructions on how to compromise systems. We do NOT
                      host or link to leaked data. Any misuse of the information
                      provided on this platform for illegal activities is
                      strictly prohibited.
                    </p>
                  </div>
                </Card>
              </section>

              {/* Professional Advice */}
              <section className="animate-fade-in-up animation-delay-600" data-id="element-924">
                <h2 className="text-2xl font-bold text-slate-100 mb-4 font-mono" data-id="element-925">
                  Professional Advice
                </h2>
                <Card glass padding="lg" data-id="element-926">
                  <p className="text-slate-400 leading-relaxed" data-id="element-927">
                    This platform is designed to provide guidance and best
                    practices. It does NOT replace the need for professional
                    security consultants, legal counsel, or compliance auditors.
                    For critical systems or legal compliance matters, please
                    engage qualified professionals.
                  </p>
                </Card>
              </section>

              {/* Jurisdiction */}
              <section className="animate-fade-in-up animation-delay-700" data-id="element-928">
                <h2 className="text-2xl font-bold text-slate-100 mb-4 font-mono" data-id="element-929">
                  Jurisdiction & Compliance
                </h2>
                <Card glass padding="lg" data-id="element-930">
                  <p className="text-slate-400 leading-relaxed" data-id="element-931">
                    Content is designed to be globally applicable and aligned
                    with international standards. Users must comply with local
                    laws and regulations. Some recommendations may not be legal
                    or applicable in all jurisdictions. Consult local legal
                    counsel when implementing security measures.
                  </p>
                </Card>
              </section>

              {/* Updates */}
              <section className="animate-fade-in-up animation-delay-800" data-id="element-932">
                <h2 className="text-2xl font-bold text-slate-100 mb-4 font-mono" data-id="element-933">
                  Updates to Disclaimer
                </h2>
                <Card glass padding="lg" data-id="element-934">
                  <p className="text-slate-400 leading-relaxed" data-id="element-935">
                    This disclaimer may be updated without notice. Continued use
                    of the platform constitutes acceptance of any changes. For
                    questions regarding this disclaimer, please contact us
                    through our{' '}
                    <Link to="/about/contact" className="text-cyan-400 hover:text-cyan-300 underline" data-id="element-936">
                      contact page
                    </Link>
                    .
                  </p>
                </Card>
              </section>
            </div>

            {/* Sidebar */}
            <div className="space-y-6" data-id="element-937">
              <Card glass padding="lg" className="sticky top-24 animate-fade-in-up animation-delay-900" data-id="element-938">
                <h3 className="text-lg font-bold text-slate-100 mb-4 font-mono" data-id="element-939">
                  Quick Links
                </h3>
                <div className="space-y-2" data-id="element-940">
                  <Link to="/about/mission" className="block p-2 rounded hover:bg-slate-800/50 text-slate-400 hover:text-cyan-400 transition-colors" data-id="element-941">
                    Mission & Vision
                  </Link>
                  <Link to="/about/scope" className="block p-2 rounded hover:bg-slate-800/50 text-slate-400 hover:text-cyan-400 transition-colors" data-id="element-942">
                    Scope & Non-Guarantee
                  </Link>
                  <Link to="/about/standards" className="block p-2 rounded hover:bg-slate-800/50 text-slate-400 hover:text-cyan-400 transition-colors" data-id="element-943">
                    Standards Mapping
                  </Link>
                  <Link to="/about/changelog" className="block p-2 rounded hover:bg-slate-800/50 text-slate-400 hover:text-cyan-400 transition-colors" data-id="element-944">
                    Changelog
                  </Link>
                  <Link to="/about/governance" className="block p-2 rounded hover:bg-slate-800/50 text-slate-400 hover:text-cyan-400 transition-colors" data-id="element-945">
                    Governance
                  </Link>
                  <Link to="/about/disclaimer" className="block p-2 rounded bg-cyan-500/10 text-cyan-400 font-medium border border-cyan-500/20" data-id="element-946">
                    Legal Disclaimer
                  </Link>
                  <Link to="/about/contact" className="block p-2 rounded hover:bg-slate-800/50 text-slate-400 hover:text-cyan-400 transition-colors" data-id="element-947">
                    Contact Us
                  </Link>
                </div>

                <div className="mt-8 pt-6 border-t border-slate-800" data-id="element-948">
                  <h4 className="text-sm font-bold text-slate-400 uppercase mb-4 font-mono" data-id="element-949">
                    Start Learning
                  </h4>
                  <Link to="/start" className="block w-full" data-id="element-950">
                    <Button variant="primary" fullWidth data-id="element-951">
                      Get Started <ArrowRight className="ml-2 h-4 w-4" data-id="element-952" />
                    </Button>
                  </Link>
                </div>
              </Card>
            </div>
          </div>
        </Container>
      </Section>
    </Layout>;
}